// Adapted from Unlumen UI's Animated List (Léo Wicki, MIT, via the 21st.dev catalog): new items spring in from the top.
import type { ReactNode } from "react";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";

export function AnimatedList<T extends { id: string | number }>({
  items,
  renderItem,
  maxVisible = 8,
  gap = 8,
  className,
}: {
  /** index 0 = newest */
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  maxVisible?: number;
  gap?: number;
  className?: string;
}) {
  const reduced = useReducedMotion();
  const spring = { type: "spring" as const, stiffness: 350, damping: 28 };
  return (
    <div className={className} style={{ display: "flex", flexDirection: "column", gap }}>
      <AnimatePresence mode="popLayout" initial={false}>
        {items.slice(0, maxVisible).map((item, index) => (
          <motion.div
            key={item.id}
            layout={!reduced}
            initial={reduced ? false : { opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={reduced ? { opacity: 0 } : { opacity: 0, scale: 0.9 }}
            transition={{ ...spring, layout: spring }}
          >
            {renderItem(item, index)}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
